import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Graphics } from "../actions/apiActions";
import { generateDeviceListForUI } from "../helpers/utils";


export const graphicsDefaultState = {
  graphicsStrings: {
    horizontalGraphic: "",
    verticalGraphic: "",
  },
  verticalLoadedGraphics: [],
  horizontalLoadedGraphics: [],
  selectedView: null,
  error: "",
  lastUserCommandFromUI: {  // this is the last given command by user, we use it to compare the current state between edgeUnit's valves positions and what the user's last command
    device: "",
    hwId: "",
    commandName: "",
    isActivating: false
  },
  currentPendingCommands: [],
};

export const fetchSVGGraphics = createAsyncThunk(
  "graphics/fetchSVGGraphics",
  async (data, thunk) => {
    const { systemId, args } = data;
    const { config } = thunk.getState().config[systemId].system;
    if (!config || !args.Graphic) {
      return { response: "error", systemId, args };
    }
    const payload = {
      CustomerId: config.CUSTOMER_ID,
      DeviceId: config.DEVICE_ID,
      Graphic: args.Graphic,
    };
    try {
      const response = await Graphics.get(config.CONFIGURATION_URL, payload);
      return { response, systemId, args };
    } catch (e) {
      console.log(e);
      return { response: "error", systemId, args };
    }
  }
);

// Thunk to get devicesList from devicesDuck
export const getDevicesListFromDevicesDuck = createAsyncThunk(
  "graphics/getDevicesListFromDevicesDuck",
  async (data, thunk) => {
    const { systemId } = data;
    const storeState = thunk.getState();
    const formattedEntries = storeState.realtime[systemId].devices.formattedEntries;
    const ui = storeState.ui[systemId]?.ui || {};
    const alarmsEntries = storeState.realtime[systemId].alarms?.entries;
    const extraDiagnostics = storeState.realtime[systemId].devices.extraDiagnostics;
    const devicesList = generateDeviceListForUI(formattedEntries, false, ui, alarmsEntries, extraDiagnostics);
    const configEntries = storeState.config[systemId].devicesConfigs.entries;
    return { devicesList, configEntries, systemId };
  }
);

const graphicsSlice = createSlice({
  name: "graphics",
  initialState: graphicsDefaultState,
  reducers: {
    setLastUsedCommand(state, action) {
      // console.log("setLastUsedCommand action", action);
      state.lastUserCommandFromUI.device = action.payload.device;
      state.lastUserCommandFromUI.commandName = action.payload.commandName;
      state.lastUserCommandFromUI.isActivating = action.payload.isActivating;
      state.lastUserCommandFromUI.hwId = action.payload.hwId;
      state.currentPendingCommands.push(action.payload);
    },
    removePendingCommand(state, action) {
      // console.log("removePendingCommand action", action);
      // console.log("state.currentPendingCommands", state.currentPendingCommands);
      state.currentPendingCommands = state.currentPendingCommands.filter((command) => command.hwId !== action.payload.hwId
        && command.commandName !== action.payload.commandName);
    },
    setSelectedView(state, action) {
      state.selectedView = action.payload.selectedViewItem;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSVGGraphics.fulfilled, (state, action) => {
        // console.log("fetchSVGGraphics.fulfilled action", action);
        if (action.payload.response === "error") {
          state.error = true;
        } else if (action.payload.args.Orientation === "horizontal") {
          state.graphicsStrings.horizontalGraphic = action.payload.response.toString();
          // const g = {name: action.payload.args.Name, svg: action.payload.response.toString()}
          // state.horizontalLoadedGraphics.push(g);
          // console.log("horizontalLoadedGraphics", state.horizontalLoadedGraphics);
          state.error = false;

        } else if (action.payload.args.Orientation === "vertical") {
          state.graphicsStrings.verticalGraphic = action.payload.response.toString();
          // const g = {name: action.payload.args.Name, svg: action.payload.response.toString()}
          // state.verticalLoadedGraphics.push(g);
          // console.log("verticalLoadedGraphics", state.verticalLoadedGraphics);
          state.error = false;
        }
      })
      .addCase(fetchSVGGraphics.rejected, (state, action) => {
        state.error = true;
      });
  },
});

export const { setLastUsedCommand, removePendingCommand, setSelectedView } = graphicsSlice.actions;

export default graphicsSlice.reducer;
